/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Table, Tag, Input, Tooltip, Modal, Form } from "antd";
import { Space, Button, Card, Popconfirm, Avatar, Layout } from "antd";
import {
  ALL_INV_PRODUCT,
  EDIT_PRODUCT,
  IMAGE_BASE_URL,
} from "../../constants/api";
import { CURRENCY } from "../../constants/constent";

function ProductInventoryTable() {
  const { Content } = Layout;

  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  //
  const [visible, setVisible] = useState(false);
  const [row, setRow] = useState(null);
  const [stockQty, setStockQty] = useState("0");

  const handleAddStock = () => {
    if (stockQty && !isNaN(stockQty)) {
      const jsonData = {
        id: row.id,
        title: row.title,
        sub_category: row.sub_category.id,
        brand: row.brand.id,
        sku_code: row.sku_code,
        barcode: row.barcode,
        avl_stock: stockQty,
        price: row.price,
        mrp: row.mrp,
        tax: row.tax,
        min_cart: row.min_cart,
        short_description: row.short_description,
        description: row.description,
        meta_title_new: row.meta_title_new,
        meta_title: row.meta_title,
        meta_description: row.meta_description,
        meta_keyword: row.meta_keyword,
        tags: row.tags,
        rating: row.rating,
        image: Array.from(row.sliders).map((element) => element.files.id),
      };

      const successFn = function (data) {
        if (data.status === true) {
          setVisible(false);
          setLoading(false);
          getData();
          displayMessage(SUCCESS_MESSAGE, data.message);
        } else {
          setLoading(false);
          displayMessage(ERROR_MSG_TYPE, data.message);
        }
      };
      const errorFn = function () {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
      };
      postAPI(EDIT_PRODUCT, jsonData, successFn, errorFn);
    } else {
      alert("Please enter a valid stock quantity");
    }
  };
  useLayoutEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        const rData = data["data"].map((row, index) => ({
          key: index,
          id: index + 1,
          title: row.title,
          price: `${CURRENCY} ${row.price}`,
          sub_category: row.sub_category.name,
          category: row.sub_category.category.title,
          sub_category_tag: (
            <span>
              <Tag color="orange">{row.sub_category.category.title}</Tag>
              <Tag color="processing">{row.sub_category.name}</Tag>
            </span>
          ),
          brand: row.brand.title,
          brand_tag: <Tag color="processing">{row.brand.title}</Tag>,
          image: (
            <Avatar.Group shape="square">
              {row.sliders.map((item) => (
                <Avatar
                  shape="square"
                  src={IMAGE_BASE_URL + item.files.filePath}
                />
              ))}
            </Avatar.Group>
          ),
          avl_stock: (
            <Tooltip
              title={
                `Available Stock: ` +
                row.avl_stock +
                ` | Max Stock: ` +
                row.min_cart
              }
            >
              <Tag
                color={`${row.avl_stock <= row.min_cart ? "error" : "green"}`}
              >
                QTY: {row.avl_stock}
              </Tag>
            </Tooltip>
          ),
          sku_code: row.sku_code,
          barcode: row.barcode,
          action: (
            <Space>
              <Popconfirm
                title="Change the stock qty"
                description="Are you sure to change the stock?"
                onConfirm={() => {
                  setRow(row);
                  setStockQty(row.avl_stock);
                  setVisible(true);
                }}
                okText="Submit"
                cancelText="Cancel"
              >
                <Button loading={loading} disabled={loading} danger>
                  Manage Stock
                </Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(rData);
        setFilteredData(rData);
        setLoading(false);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    getAPI(ALL_INV_PRODUCT, successFn, errorFn, {});
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (room) =>
        room.sku_code.toLowerCase().includes(value.toLowerCase()) ||
        room.barcode.toLowerCase().includes(value.toLowerCase()) ||
        room.title.toLowerCase().includes(value.toLowerCase()) ||
        room.category.toLowerCase().includes(value.toLowerCase()) ||
        room.sub_category.toLowerCase().includes(value.toLowerCase()) ||
        room.price.toString().includes(value)
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "id",
      width: 50,
    },
    {
      title: "SKU",
      dataIndex: "sku_code",
      width: 50,
    },
    {
      title: "Barcode",
      dataIndex: "barcode",
      width: 50,
    },
    {
      title: "Image",
      dataIndex: "image",
      width: 50,
    },
    {
      title: "Category | Sub",
      dataIndex: "sub_category_tag",
      width: 50,
    },
    {
      title: "Brand",
      dataIndex: "brand_tag",
      width: 50,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 150,
    },
    {
      title: "Price",
      dataIndex: "price",
      width: 50,
    },
    {
      title: "Stock",
      dataIndex: "avl_stock",
      width: 50,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Low Stock Products"
            extra={
              <Space>
                <Input
                  placeholder="Search by Name or Category"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
        {/* Modal for adding stock */}
        <Modal
          title="Update Stock Quantity"
          visible={visible}
          onOk={handleAddStock}
          onCancel={() => setVisible(false)}
          okText="Add Stock"
          cancelText="Cancel"
        >
          <Form initialValues={{ avl_stock: stockQty }} layout="vertical">
            <Form.Item
              label="Stock Quantity"
              name="avl_stock"
              rules={[
                { required: true, message: "Please enter the stock quantity!" },
                {
                  pattern: /^[0-9]+$/,
                  message: "Stock must be a number",
                },
              ]}
            >
              <Input
                type="number"
                min={1}
                value={stockQty}
                defaultValue={stockQty}
                onChange={(e) => setStockQty(e.target.value)}
                placeholder="Enter stock quantity"
              />
            </Form.Item>
          </Form>
        </Modal>
      </Layout>
    </>
  );
}

export default ProductInventoryTable;
